export default __webpack_public_path__ + "static/media/TheLostAcornCity.e2b7574b.png";